import { all, fork, put, takeLatest, call, takeEvery } from 'redux-saga/effects';
import {
    getAverageDomesticQuotedDays,
    getAverageDomesticActualDays,
    getTransitTimesByServiceLevel,
    getTransitTimesByTimeframe,
    getTransitTimesSummary,
} from '../../helpers';
import {
    transitTimesAnalyticsApiResponseSuccess,
    transitTimesAnalyticsApiResponseError,
} from './actions';
import { TransitTimesAnalyticsActionTypes } from './constants';

export function* getAverageDomesticQuotedDaysSaga({ payload: { query } }) {
    try {
        const response = yield call(getAverageDomesticQuotedDays, query);
        yield put(transitTimesAnalyticsApiResponseSuccess(TransitTimesAnalyticsActionTypes.GET_AVERAGE_DOMESTIC_QUOTED_DAYS, response.data));
    } catch (error) {
        yield put(transitTimesAnalyticsApiResponseError(TransitTimesAnalyticsActionTypes.GET_AVERAGE_DOMESTIC_QUOTED_DAYS, error));
    }
}

export function* getAverageDomesticActualDaysSaga({ payload: { query } }) {
    try {
        const response = yield call(getAverageDomesticActualDays, query);
        yield put(transitTimesAnalyticsApiResponseSuccess(TransitTimesAnalyticsActionTypes.GET_AVERAGE_DOMESTIC_ACTUAL_DAYS, response.data));
    } catch (error) {
        yield put(transitTimesAnalyticsApiResponseError(TransitTimesAnalyticsActionTypes.GET_AVERAGE_DOMESTIC_ACTUAL_DAYS, error));
    }
}

export function* getTransitTimesByServiceLevelSaga({ payload: { query } }) {
    try {
        const response = yield call(getTransitTimesByServiceLevel, query);
        yield put(transitTimesAnalyticsApiResponseSuccess(TransitTimesAnalyticsActionTypes.GET_TRANSIT_TIMES_BY_SERVICE_LEVEL, response.data));
    } catch (error) {
        yield put(transitTimesAnalyticsApiResponseError(TransitTimesAnalyticsActionTypes.GET_TRANSIT_TIMES_BY_SERVICE_LEVEL, error));
    }
}

export function* getTransitTimesByTimeframeSaga({ payload: { query } }) {
    try {
        const response = yield call(getTransitTimesByTimeframe, query);
        yield put(transitTimesAnalyticsApiResponseSuccess(TransitTimesAnalyticsActionTypes.GET_TRANSIT_TIMES_BY_TIMEFRAME, response.data));
    } catch (error) {
        yield put(transitTimesAnalyticsApiResponseError(TransitTimesAnalyticsActionTypes.GET_TRANSIT_TIMES_BY_TIMEFRAME, error));
    }
}

export function* getTransitTimesSummarySaga({ payload: { query } }) {
    try {
        const response = yield call(getTransitTimesSummary, query);
        yield put(transitTimesAnalyticsApiResponseSuccess(TransitTimesAnalyticsActionTypes.GET_TRANSIT_TIMES_SUMMARY, response.data));
    } catch (error) {
        yield put(transitTimesAnalyticsApiResponseError(TransitTimesAnalyticsActionTypes.GET_TRANSIT_TIMES_SUMMARY, error));
    }
}

export function* watchGetAverageDomesticQuotedDaysSaga() {
    yield takeLatest(TransitTimesAnalyticsActionTypes.GET_AVERAGE_DOMESTIC_QUOTED_DAYS, getAverageDomesticQuotedDaysSaga);
}

export function* watchGetAverageDomesticActualDaysSaga() {
    yield takeLatest(TransitTimesAnalyticsActionTypes.GET_AVERAGE_DOMESTIC_ACTUAL_DAYS, getAverageDomesticActualDaysSaga);
}

export function* watchGetTransitTimesByServiceLevelSaga() {
    yield takeLatest(TransitTimesAnalyticsActionTypes.GET_TRANSIT_TIMES_BY_SERVICE_LEVEL, getTransitTimesByServiceLevelSaga);
}

export function* watchGetTransitTimesByTimeframeSaga() {
    yield takeLatest(TransitTimesAnalyticsActionTypes.GET_TRANSIT_TIMES_BY_TIMEFRAME, getTransitTimesByTimeframeSaga);
}

export function* watchGetTransitTimesSummarySaga() {
    yield takeLatest(TransitTimesAnalyticsActionTypes.GET_TRANSIT_TIMES_SUMMARY, getTransitTimesSummarySaga);
}

function* transitTimesAnalyticsSaga() {
    yield all([
        fork(watchGetAverageDomesticQuotedDaysSaga),
        fork(watchGetAverageDomesticActualDaysSaga),
        fork(watchGetTransitTimesByServiceLevelSaga),
        fork(watchGetTransitTimesByTimeframeSaga),
        fork(watchGetTransitTimesSummarySaga),
    ]);
}

export default transitTimesAnalyticsSaga;
